/**
 * Initializes header wrap logic for a specific Shopify section.
 * @param {string} sectionId - The ID of the current Shopify section.
 * @param {boolean} isDrawerLayout - Whether the section layout is set to 'drawer'.
 */
function initHeaderWrap(sectionId, isDrawerLayout) {
    
    document.addEventListener("DOMContentLoaded", () => {
        const headerSection = document.getElementById(`shopify-section-${sectionId}`);
        if (!headerSection) return;

       
        document.documentElement.style.setProperty('--header-height', `${headerSection.clientHeight.toFixed(2)}px`);

        const navList = document.querySelector(".contents.unstyled-list");
        const logo = document.querySelector(".header__logo");
        const localizationSelectors = document.querySelector(".localization-selectors");
        const hamburgerButton = document.querySelector(
            'button[aria-controls="sidebar-menu"]'
        );


        function centerLogoGrid(forceCenter = false) {
            if (forceCenter) {
                headerSection.style.setProperty(
                    "--header-grid",
                    '"primary-nav . logo . secondary-nav" / 1fr 0.5fr auto 0.5fr 1fr'
                );
            } else {
                headerSection.style.removeProperty("--header-grid");
            }
        }

        function restoreNormalStyles() {
      
            if (navList) navList.style.display = ""; 
            
            if (logo) {
                logo.style.marginInline = "";
                logo.style.display = "";
                logo.style.textAlign = "";
            }
            if (localizationSelectors) {
                localizationSelectors.style.display = "";
            }
            if (hamburgerButton) {
                if (!isDrawerLayout) {
                    hamburgerButton.classList.add("md:hidden");
                }
                hamburgerButton.style.display = "";
            }
            centerLogoGrid(false);
        }

        function applyWrappedStyles() {
            if (navList) navList.style.display = "none"; 
            
            if (logo) {
                logo.style.marginInline = "auto";
                logo.style.display = "block";
                logo.style.textAlign = "center";
            }
            if (localizationSelectors) {
                localizationSelectors.style.display = "none";
            }
            if (hamburgerButton) {
                hamburgerButton.classList.remove("md:hidden");
                hamburgerButton.style.display = "block";
            }
            centerLogoGrid(true);
        }

        function isNavWrapped() {
            if (!navList || navList.children.length === 0) return false;
            
            const firstTop = navList.children[0].offsetTop;
            for (const item of navList.children) {
                if (item.offsetTop > firstTop) {
                    return true;
                }
            }
            return false;
        }

        
        function checkNavWrap() {
            if (!navList || navList.children.length === 0) return;
            
            const isFixed = navList.style.display === "none";
            let wrapped = false;
            
            if (isFixed) {
                restoreNormalStyles(); 

                wrapped = isNavWrapped();
                
                if (wrapped) {
                    applyWrappedStyles();
                } else {
    
                }
            } else {
                
                wrapped = isNavWrapped();
                
                if (wrapped) {
                    applyWrappedStyles();
                } else {
                    restoreNormalStyles(); 
                }
            }
        }

        checkNavWrap();

        let resizeTimer;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(checkNavWrap, 150);
        });
    });
}